import type { TourDefinition } from '../types'

export const aiGovernanceTour: TourDefinition = {
  id: 'ai-governance',
  title: 'AI Governance Tour',
  description: 'Understand how Vharta enforces AI safety, model access tiers, and usage quotas.',
  icon: 'BarChart3',
  roles: ['tenant_owner', 'tenant_admin'],
  route: '/tenant/ai/governance',
  estimatedMinutes: 3,
  steps: [
    {
      element: '[data-tour-id="ai-governance-overview"]',
      popover: {
        title: 'AI Governance Overview',
        description: 'Monitor AI usage, cost, and security events across all LLM providers in your tenant.',
      },
      roles: ['tenant_owner', 'tenant_admin'],
      aiContext: 'What AI governance metrics should I watch to detect misuse?',
    },
    {
      element: '[data-tour-id="ai-model-tiers"]',
      popover: {
        title: 'Model Access Tiers',
        description: 'OPA policies enforce which models each user can access based on license tier.',
      },
      roles: ['tenant_owner', 'tenant_admin'],
      aiContext: 'How do I change which AI models my team members can access?',
    },
    {
      element: '[data-tour-id="ai-security-scans"]',
      popover: {
        title: 'Security Scan Log',
        description: 'Every prompt is scanned for injection attacks, PII, and policy violations. Results are logged here.',
      },
      roles: ['tenant_owner', 'tenant_admin'],
      aiContext: 'What happens when a prompt fails a security scan?',
    },
    {
      element: '[data-tour-id="ai-quota-panel"]',
      popover: {
        title: 'Usage Quotas',
        description: 'Set monthly token and cost limits per user or team. The gateway enforces these in real time.',
      },
      roles: ['tenant_owner', 'tenant_admin'],
      aiContext: 'How do I set a monthly AI spend limit for a specific team?',
    },
  ],
}
